/* Destaques (Coleções): o vídeo só aparece quando realmente começa a tocar.
   Se o navegador bloquear o autoplay, quem fica na bolinha é a foto de capa. */
(function () {
  function init() {
    var videos = document.querySelectorAll('.collections-section video.showcase-video[data-src]');
    if (!videos.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return; // mantem a foto de capa

    Array.prototype.forEach.call(videos, function (video) {
      video.muted = true;
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });
    });

    function start(video) {
      if (!video.dataset.src) return;
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          // Autoplay bloqueado pelo navegador: a foto de capa continua visivel.
        });
      }
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, start);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          start(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '100px' });

    Array.prototype.forEach.call(videos, function (video) {
      observer.observe(video);
    });
  }

  /* Os videos ficam logo abaixo do banner no celular. Para nao disputar a internet com a imagem
     principal, comecam assim que ela terminar de carregar - com limite de 2,5 s, para nunca
     depender de apps ou outros recursos lentos da pagina. */
  var started = false;
  function startOnce() {
    if (started) return;
    started = true;
    init();
  }

  function waitHero() {
    var heroes = document.querySelectorAll('img[fetchpriority="high"]');
    var hero = null;
    for (var i = 0; i < heroes.length; i++) {
      if (heroes[i].offsetWidth > 0 || heroes[i].offsetHeight > 0) { hero = heroes[i]; break; }
    }
    if (!hero || (hero.complete && hero.naturalWidth > 0)) {
      startOnce();
      return;
    }
    hero.addEventListener('load', startOnce, { once: true });
    hero.addEventListener('error', startOnce, { once: true });
    setTimeout(startOnce, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitHero);
  } else {
    waitHero();
  }
})();
